import styled from '@emotion/styled';

export default styled.section`
    .sections-hero-black {
        background-color: transparent;

        .layout-container {
            .hero-header {
                padding: 4em 0 0;
            }
        }
    }

    .blog-main-news {
        .section-articles {
            padding: 2em 0;
        }
    }
`;
